import { render } from "./HelixifyVuetifyDefinitions.vue?vue&type=template&id=25656178"
import script from "./HelixifyVuetifyDefinitions.vue?vue&type=script&lang=js"
export * from "./HelixifyVuetifyDefinitions.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__